import humanJson from './human.json';

const human = {
    ...humanJson
};

export default human;